module.exports = __webpack_public_path__ + "static/media/POLY.d40bd6a9.svg";